<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" *ngIf="invoices">
        <dx-data-grid
            #dataGrid
            [dataSource]="invoices"
            keyExpr="id"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="id" width="80"></dxi-column>
            <dxi-column dataField="invoiceDate" width="125"></dxi-column>
            <dxi-column dataField="vendor.companyName" caption="Vendor" width="175"></dxi-column>
            <dxi-column dataField="referenceNumber" caption="Reference #" width="125"></dxi-column>
            <dxi-column dataField="total" width="150" [format]="'$#,##0.00'"></dxi-column>
            <dxi-column dataField="note" width="250"></dxi-column>
            <!-- <dxi-column dataField="readyToExport" width="125"></dxi-column> -->
            <dxi-column dataField="quickBooksId" caption="QB ID" width="150"></dxi-column>
            <dxi-column dataField="quickBooksLastExport" width="150"></dxi-column>
            <dxi-column></dxi-column>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="purchase-order-invoices-grid"></dxo-state-storing>
            <dxo-selection [mode]="'multiple'"></dxo-selection>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-success" (click)="open(dataGrid.instance.getSelectedRowsData()[0])" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
                    Open
                </button>
                <button
                    class="btn btn-danger ms-2"
                    (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                    [hidden]="!auth.hasRole('Administrator')"
                >
                    Delete
                </button>
                <button
                    class="btn btn-sm btn-success ms-2"
                    (click)="payWithoutQuickBooks(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Pay w/o QuickBooks
                </button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="invoices" class="me-3">
                    <strong>
                        {{ dataGrid.instance.totalCount() + ' items' }}
                        {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                    </strong>
                </span>
            </div>
        </dx-data-grid>
    </div>
</div>
